/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioFilasCV from './controladorVista/formularioFilasCV';
import TablaFilasCV from './controladorVista/tablaFilasCV';
import { estadoIncial, reductor } from './reductorFilas';

const Filas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaFilasCV />
        <FormularioFilasCV />
    </ProveedorEstado>
);

export default Filas;
